import React from 'react'
import { useConnect } from 'sb-redux-hook'

import { OverlayLoader } from 'components/_new/ui'


const RequestLoader: React.FunctionComponent = () => {
  const { isVisible } = useConnect({
    isVisible: 'models.ui.isRequestLoaderVisible',
  })

  return (
    <OverlayLoader isVisible={isVisible} name="requestLoader" />
  )
}


export default RequestLoader
